import { createUseStyles } from "react-jss";
import { grey1 } from "./theme";

const globalStyle = createUseStyles({
  "@global": {
    "*": {
      boxSizing: "border-box",
      margin: 0,
      padding: 0,
      listStyleType: "none",
    },
    "h1, h2, h3, h4, h5": {
      marginBottom: 0,
    },

    "body,body *:not([class*='customFont']):not([class*='customFont2']):not([class*='customFont'] *),button":
      {
        fontFamily: "Lexend, sans-serif !important",
      },

    ".ant-form-item": {
      marginBottom: "32px",
    },
    p: {
      marginBottom: 0,
    },
    ".ant-btn-primary": {
      boxShadow: "0 2px 0 rgba(5,145,255,.1)",
    },
    "p, label": {},
    ".ant-input-affix-wrapper-focused": {
      boxShadow: "0 0 0 2px rgba(5,145,255,.1)",
    },
    'input[type="number"]::-webkit-outer-spin-button,input[type="number"]::-webkit-inner-spin-button':
      {
        "-webkit-appearance": "none",
        margin: 0,
      },
    ".ant-card": {
      overflow: "hidden",
    },
    ".ant-tabs": {
      gap: 24,
    },
    ":where(.css-dev-only-do-not-override-1bu589w).ant-card .ant-card-cover img, :where(.css-dev-only-do-not-override-1bu589w).ant-card .ant-card-cover img+.ant-image-mask":
      {
        borderRadius: "unset",
      },
    "::-webkit-scrollbar": { width: "6px" },
    "::-webkit-scrollbar-track": {
      background: grey1,
    },
    "::-webkit-scrollbar-thumb": { background: "#c1c1c1" },
    "::-webkit-scrollbar-thumb:hover": { background: "#b1b1b1" },
    h5: {
      fontWeight: 500,
    },
    ".ant-table-thead .ant-table-cell": {
      fontWeight: "500 !important",
    },
  },
});

export default globalStyle;
